export default {
    activeClientLimit: 'Active Client Limit',
    addons: 'Addons',
    billingContact: 'Billing Contact',
    billingFrequency: 'Billing Frequency',
    billingMethod: 'Billing Method',
    changeBillingContact: 'Change Billing Contact',
    changeBillingMethod: 'Change Billing Method',
    clientsButton: 'Change Client Limit',
    clientsLabel: 'Clients',
    clientsValue: '{{clients}}/{{limit}} (active/limit)',
    clientsWarning: 'Adjust your limit to add more clients',
    gracePeriod: '(Grace period)',
    mailPoints: 'MailPoints',
    mailPointsButton: 'Buy MailPoints',
    newPlanStart: 'New plan effective on',
    plan: 'Plan',
    planCancelButton: 'Cancel Plan',
    planChangeButton: 'Change Plan',
    price: 'Price',
    receipts: 'Receipts',
    receiptsButton: 'Request Receipts',
    resetDate: 'Your limit resets',
    sendOrdersButton: 'Change Limit',
    sendOrdersLabel: 'Send Orders',
    sendOrdersValue: '{{sent}}/{{limit}} (sent/limit)',
    sendOrdersWarning: 'Adjust your limit to continue sending',
    teamMembersButton: 'Change Team Member Limit',
    teamMembersLabel: 'Team Members',
    teamMembersLimit: 'Team Member Limit',
    teamMembersValue: '{{members}}/{{limit}} (licensed/limit)',
    title: 'Billing - Makeleaps',
    virtualAccounts: 'Virtual Accounts',
    virtualAccountsValue: '{{count}}/{{limit}} (in use/limit)',
};
